import { z } from 'zod'

export const wealthFeedJobStatusSchema = z.enum(['complete', 'no_match', 'failed'])

export const wealthFeedPersonSchema = z
  .object({
    inputId: z.string(),
    validMatch: z.union([z.literal(0), z.literal(1)]),
    age: z.number().nullable().optional(),
    incomeEst: z.union([z.string(), z.number()]).nullable().optional(),
    zip: z.string().nullable().optional(),
    netWorth: z.number().nullable().optional(),
    phone1Dnc: z
      .union([z.literal(0), z.literal(1)])
      .nullable()
      .optional(),
    mostRecentEventType: z.string().nullable().optional(),
    mostRecentEventDate: z.string().nullable().optional(),
    currentJobTitle: z.string().nullable().optional(),
    prop1HomeValue: z.number().nullable().optional(),
  })
  .passthrough()

export const wealthFeedJobSchema = z.object({
  jobId: z.number().int(),
  // Salesforce Lead Id (Id field), never External_Id__c. Absent for enrich.failed events
  // where no inputId is returned; present for complete and no_match records.
  salesforceLeadId: z.string().optional(),
  status: wealthFeedJobStatusSchema,
  completedAt: z.string().datetime(),
  person: wealthFeedPersonSchema.optional(),
})

export type WealthFeedJobRecord = z.infer<typeof wealthFeedJobSchema>
export type WealthFeedJobStatus = z.infer<typeof wealthFeedJobStatusSchema>
export type WealthFeedPerson = z.infer<typeof wealthFeedPersonSchema>
export type CreateWealthFeedJobRecord = WealthFeedJobRecord
